import logo from './logo.svg';
import './App.css';
import { Routes,Route } from 'react-router-dom';
import Home from './Pages/Home';
import PageNotFound from './Pages/PageNotFound';
import ErrorPage from './Pages/ErrorPage';
import CategoryPage from './Pages/CategoryPage';
// import 'primeflex/primeflex.css';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import Tnc from './Pages/Tnc';
import Subscribe from './Pages/Subscribe';

function App() {
  return (
    <>
    <Routes>
      <Route path='/' element={<Home/>} />
      <Route path='*' element={<PageNotFound/>}/>
      <Route path='/error' element={<ErrorPage/>} />
      <Route path='/Category/:category' element={<CategoryPage/>} />
      <Route path='/tnc' element={<Tnc/>} />
      <Route path='/subscribe' element={<Subscribe/>} />

    </Routes>
    </>
  );
}

export default App;
